import {
  Message,
  MessageBox
} from 'element-ui';
export default {
  stMessage: function (msg, type) {
    Message({
      message: msg,
      type: type ? 'success' : 'warning'
    });
  },
  stConfirm: function (msg, successFun, cancelFun) {
    MessageBox.confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      showCancelButton: true
    }).then((res) => {
      successFun && successFun(res)
    }).catch((err) => {
      cancelFun && cancelFun(err)
    });
  },
  stConfirm2: function (config) {
    return MessageBox.confirm(config.msg, config.title || '提示', {
      confirmButtonText: config.confirmText || '确定',
      cancelButtonText: config.cancelText || '取消',
      type: config.type || 'success',
      showCancelButton: config.showCancel
    })
  },
}